module.exports = __webpack_public_path__ + "static/media/resilient-coders.78b4fd87.png";